const key = 'FIRMWARES__';

exports.SET_CREATE_EDIT_FIRMWARES = `${key}SET_CREATE_EDIT_FIRMWARES`;
exports.SET_FIRMWARES_ID_TO_EDIT = `${key}SET_FIRMWARES_ID_TO_EDIT`;
